import { render, staticRenderFns } from "./CategoriesTable.vue?vue&type=template&id=2115ba72&scoped=true&"
import script from "./CategoriesTable.vue?vue&type=script&lang=js&"
export * from "./CategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115ba72",
  null
  
)

export default component.exports